import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Ref, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getThousandMoney } from '@/utils/index'
import { confirmRepairOrderApplyInvoice } from '@/apis/insurance'
import { ReapirRenderListItemType, DevicePayInfoType } from '@/types/insurance'
import ApplyInvoiceWrap from '../components/apply-invoice-wrap.vue'
import { UpgradeMaintenanceDetail } from '@/types/malfunction-repair'
type UpdataMaintenanceStoreData = UpgradeMaintenanceDetail['invoiceInfo']

export default /*#__PURE__*/_defineComponent({
  __name: 'apply-invoice',
  setup(__props) {

const detail: Ref<DevicePayInfoType | null> = ref(null)
const $route = useRoute()
const $router = useRouter()

const repairType = $route.query.repairType as string
const costInfoStyle = {
  fontWeight: 'bold',
}
const guid = ref('')

async function initStorageData(data: ReapirRenderListItemType | UpdataMaintenanceStoreData) {
  guid.value = data.guid
  // 根据repairType判断维修单类型
  if (repairType === 'updataMaintenance') {
    let updataMaintenanceData = data as UpdataMaintenanceStoreData
    detail.value = {
      deviceCommonInfo: {
        img: data.logo,
        name: updataMaintenanceData.eq_name,
        sequence: updataMaintenanceData.repair_sn,
      },
      serviceInfoList: [
        {
          label: '设备型号',
          value: updataMaintenanceData.eq_model,
        },
        {
          label: '报修时间',
          value: updataMaintenanceData.created_at,
        },
        {
          label: '维修明细',
          value: '查看详情',
          routeInfo: {
            name: 'malfunction-upgrade-maintenance-detail',
            query: {
              guid: updataMaintenanceData.guid,
            },
          },
        },
      ],
      costInfo: [
        {
          label: '账单费用合计',
          value: `¥${getThousandMoney(updataMaintenanceData.pay_amount)}`,
          valueStyle: costInfoStyle,
        },
        {
          label: '优惠卷折扣',
          value: `无`,
          // valueStyle: costInfoStyle,
        },
      ],
      buyInfo: {
        title: '开票金额',
        price: getThousandMoney(Number(updataMaintenanceData.pay_amount)),
      },
    }
  } else {
    let repairData = data as ReapirRenderListItemType
    detail.value = {
      deviceCommonInfo: {
        img: data.logo,
        name: `维修单号: ${repairData.repair_sn}`,
        sequence: repairData.serial_number,
      },
      serviceInfoList: [
        {
          label: '设备型号',
          value: repairData.eq_model,
        },
        {
          label: '报修时间',
          value: repairData.created_at,
        },
        {
          label: '维修明细',
          value: '查看详情',
          routeInfo: {
            path: `/repairorder/${data.guid}`,
          },
        },
      ],
      costInfo: [
        {
          label: '配件费用',
          value: `¥${getThousandMoney(repairData.mate_discount_amount)}`,
          valueStyle: costInfoStyle,
        },
        {
          label: '维修工时费用',
          value: `¥${getThousandMoney(repairData.hourly_discount_amount)}`,
          valueStyle: costInfoStyle,
        },
      ],
      buyInfo: {
        title: '开票金额',
        price: getThousandMoney(Number(repairData.pay_amount)),
      },
    }
  }
}
function applySuccess() {
  $router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ApplyInvoiceWrap, {
    detail: detail.value,
    onStorageInit: initStorageData,
    onApplySuccess: applySuccess,
    guid: guid.value,
    confirmHandle: _unref(confirmRepairOrderApplyInvoice)
  }, null, 8, ["detail", "guid", "confirmHandle"]))
}
}

})